import React, { useState } from 'react';
import { Table, Button, Input, Select, Popconfirm, Space, Card } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { getSearchApi } from '../../../network/itemList';
const PayrollCostCenterList = ({ setDataSource, dataSource, t, form }) => {
  const [count, setCount] = useState(0);
  const { data: costCenters } = useQuery({
    queryKey: [queryKeys.getSearchApiCostCenters],
    queryFn: () => getSearchApi('Cost Center'),
    keepPreviousData: true,
  });
  const columns = [
    {
      title: t.costCenter,
      dataIndex: 'cost_center',
      render: (text, record, index) => (
        <Select
          placeholder={t.costCenter}
          value={record?.cost_center}
          style={{ width: '100%', marginBottom: '0px' }}
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.label ?? '')
              .toLocaleLowerCase()
              .includes(input.toLocaleLowerCase())
          }
          filterSort={(optionA, optionB) =>
            (optionA?.label ?? '')
              .toLowerCase()
              .localeCompare((optionB?.label ?? '').toLowerCase())
          }
          popupMatchSelectWidth={false}
          options={costCenters?.message?.map((user) => ({
            value: user.value,
            label: user.value,
          }))}
          onChange={(value) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              cost_center: value,
            };
            setDataSource(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.percentage,
      dataIndex: 'percentage',
      render: (text, record, index) => (
        <Input
          placeholder={t.percentage}
          style={{ width: '100%' }}
          type="number"
          min={0}
          max={100}
          value={record.percentage}
          onChange={(e) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              percentage: e.target.value,
            };
            setDataSource(newDataSource);
          }}
        />
      ),
    },

    {
      title: t.action,
      key: 'action',
      render: (text, record, index) => (
        <Space>
          <Popconfirm
            title={t.confirmDelete}
            onConfirm={() => handleDelete(record.key)}
          >
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              size="small"
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleAdd = () => {
    const newData = {
      key: count,
      due_date: dayjs(),
      invoice_portion: 100,
    };
    setDataSource([...dataSource, newData]);
    setCount(count + 1);
  };

  const handleDelete = (key) => {
    const newDataSource = dataSource.filter((item) => item.key !== key);
    setDataSource(newDataSource);
  };

  return (
    <Card>
      <Table
        className="table_custom"
        dataSource={dataSource}
        columns={columns}
        pagination={{
          hideOnSinglePage: true,
        }}
        scroll={{ x: 'max-content' }}
        // className="table"
        rowKey="key"
      />
      <Button
        onClick={handleAdd}
        type="primary"
        ghost
        style={{ marginTop: '20px', borderRadius: '6px' }}
        icon={<PlusOutlined />}
        size="small"
      >
        {t.addRow}
      </Button>
    </Card>
  );
};

export default PayrollCostCenterList;
